import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
// import { environment } from "projects/ert/src/environments/environment";
import { RamTargetTurbine } from "projects/tilmanagement/src/app/interfaces/ram-targets/ramTargets";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { environment } from "projects/tilmanagement/src/environments/environment";
import { MasterData } from "../../interfaces/ram-targets/masterData";
import { RamTargetHistory } from "../../interfaces/ram-targets/ramTargetHistory";
import { RamTargetHistoryDto } from "../../interfaces/ram-targets/ramTargetHistoryDto";
const apiHost = environment.apiUrl;

@Injectable({
  providedIn: "root",
})
export class RamTargetsHistoryService {
  newRamTargetHistory: RamTargetHistory;
  addRamTargetForm: FormGroup;

  currentRamTarget: RamTargetHistory;

  constructor(private httpClient: HttpClient, private fb: FormBuilder) {
    this.addRamTargetForm = this.fb.group({
      id: [0],
      turbineID: [0],
      serialNumber: [""],
      targetType: [""],
      jan: [0],
      feb: [0],
      mar: [0],
      apr: [0],
      may: [0],
      jun: [0],
      jul: [0],
      aug: [0],
      sep: [0],
      oct: [0],
      nov: [0],
      dec: [0],
      comments: [""],
    });
  }

  public setRamTargetHistory(data: RamTargetHistoryDto) {
    this.newRamTargetHistory = { ...this.newRamTargetHistory, ...data };
  }
  getRamTargetsHistoryDataAsync(ramTargetsId: number) {
    return this.httpClient.get<RamTargetHistory[]>(
      `${apiHost}/ram-targets/ramTargetsHistory/${ramTargetsId}`
    );
  }

  public addRamTargetHistory() {
    return this.httpClient.post(
      `${apiHost}/ram-targets/ramTargetsHistory`,
      this.newRamTargetHistory
    );
  }
}
